import {
  useAddClosingPackageItemMutation,
  useConfirmClosingPackageFormationMutation,
  useConfirmOriginalsReceiptMutation,
  useExcludeClosingPackageItemMutation,
  useRegisterClosingPackageApprovalMutation,
  useRegisterClosingPackageScanDispatchMutation,
  useRegisterOriginalsDispatchMutation,
  useRegisterOriginalsPreparedMutation,
  useStartEdoDispatchMutation,
  useRegisterEdoDispatchMutation,
  useConfirmEdoReceiptMutation,
  useReplaceClosingPackageItemMutation,
  useRestoreClosingPackageItemMutation,
} from '../api/closingPackageApi';

/**
 * Bundle of Closing Package command mutations for Action Bar / ERP Modal (FE-005+).
 * No UI — wiring only.
 */
export function useClosingPackageCommands() {
  const [addItem, addItemState] = useAddClosingPackageItemMutation();
  const [replaceItem, replaceItemState] = useReplaceClosingPackageItemMutation();
  const [excludeItem, excludeItemState] = useExcludeClosingPackageItemMutation();
  const [restoreItem, restoreItemState] = useRestoreClosingPackageItemMutation();
  const [confirmFormation, confirmFormationState] = useConfirmClosingPackageFormationMutation();
  const [registerScanDispatch, registerScanDispatchState] =
    useRegisterClosingPackageScanDispatchMutation();
  const [registerApproval, registerApprovalState] = useRegisterClosingPackageApprovalMutation();
  const [registerOriginalsPrepared, registerOriginalsPreparedState] =
    useRegisterOriginalsPreparedMutation();
  const [registerOriginalsDispatch, registerOriginalsDispatchState] =
    useRegisterOriginalsDispatchMutation();
  const [confirmOriginalsReceipt, confirmOriginalsReceiptState] =
    useConfirmOriginalsReceiptMutation();
  const [startEdoDispatch, startEdoDispatchState] = useStartEdoDispatchMutation();
  const [registerEdoDispatch, registerEdoDispatchState] = useRegisterEdoDispatchMutation();
  const [confirmEdoReceipt, confirmEdoReceiptState] = useConfirmEdoReceiptMutation();

  return {
    addItem,
    replaceItem,
    excludeItem,
    restoreItem,
    confirmFormation,
    registerScanDispatch,
    registerApproval,
    registerOriginalsPrepared,
    registerOriginalsDispatch,
    confirmOriginalsReceipt,
    startEdoDispatch,
    registerEdoDispatch,
    confirmEdoReceipt,
    states: {
      addItem: addItemState,
      replaceItem: replaceItemState,
      excludeItem: excludeItemState,
      restoreItem: restoreItemState,
      confirmFormation: confirmFormationState,
      registerScanDispatch: registerScanDispatchState,
      registerApproval: registerApprovalState,
      registerOriginalsPrepared: registerOriginalsPreparedState,
      registerOriginalsDispatch: registerOriginalsDispatchState,
      confirmOriginalsReceipt: confirmOriginalsReceiptState,
      startEdoDispatch: startEdoDispatchState,
      registerEdoDispatch: registerEdoDispatchState,
      confirmEdoReceipt: confirmEdoReceiptState,
    },
  };
}
